export default {
  cardContainer: {
    padding: '1em 1em 2em',
    gap: '1.5em',
  },
};
